// The outer macro-stepper (Connect -> Confirm route -> First shift) and the Connect
// sub-stepper (repo/intent/cloud ticks). Markup + token mapping per
// slice-2-onboarding.md §2.2 (docs/design/mockups/02-app.html:155-159, brand.css classes
// ported into app.css's .stepper/.substepper blocks).
export type OuterStep = "connect" | "confirm_route" | "first_shift";

const OUTER_STEPS: readonly { readonly key: OuterStep; readonly label: string }[] = [
  { key: "connect", label: "Connect" },
  { key: "confirm_route", label: "Confirm route" },
  { key: "first_shift", label: "First shift" },
];

export const OuterStepper = ({ active }: { readonly active: OuterStep }): React.JSX.Element => {
  const activeIndex = OUTER_STEPS.findIndex((s) => s.key === active);
  return (
    <div className="stepper" aria-label="Onboarding progress">
      {OUTER_STEPS.map((step, index) => (
        <div className="row aic" key={step.key} style={{ gap: 8 }}>
          <div
            className={`s${index < activeIndex ? " done" : ""}${index === activeIndex ? " active" : ""}`}
          >
            <span className="b">{index < activeIndex ? "✓" : index + 1}</span> {step.label}
          </div>
          {index < OUTER_STEPS.length - 1 ? <span className="line" /> : null}
        </div>
      ))}
    </div>
  );
};

export type SubStepKey = "repo" | "intent" | "cloud";
export type SubStepState = "pending" | "done" | "skipped";

export const SubStepper = ({
  states,
}: {
  readonly states: Record<SubStepKey, SubStepState>;
}): React.JSX.Element => {
  const labels: Record<SubStepKey, string> = { repo: "repo", intent: "intent", cloud: "cloud" };
  return (
    <div className="substepper" aria-label="Connect sub-steps">
      {(Object.keys(labels) as SubStepKey[]).map((key) => (
        <span key={key} className={`tick ${states[key]}`}>
          {states[key] === "done" ? "✓ " : ""}
          {labels[key]}
          {states[key] === "skipped" ? " (skipped)" : ""}
        </span>
      ))}
    </div>
  );
};
